export const catalogs = {
  catalogs: [
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: 'c8ef8091-ee2a-401e-bfb6-e893f504a5bb',
      extTargetingId: 'c8ef8091-ee2a-401e-bfb6-e893f504a5bb-extTargetingId',
      title:
        '(Only to test TOAST -Apple-Pay) AET Rush Store QA - Pre selected Menu',
      createdDate: '2024-04-06T16:28:57',
      updatedDate: '2024-04-06T16:28:57',
      startDate: '2024-04-05T16:28:57',
      endDate: '2224-04-06T16:28:57',
      displayRank: 2,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Pre selected Menu',
          shortDescription: '',
          longDescription: '',
          smallImage: [
            'https://incentdev.s3.amazonaws.com/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/c/20231211071623486/sm/Pre%20selected%20Menu.jpg',
          ],
          mediumImage: [
            'https://incentdev.s3.amazonaws.com/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/c/20231206140906683/md/Pre%20selected%20Menu.jpg',
          ],
        },
      ],
      status: 'ACTIVE',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {
        PROPERTY_1: '68a283e4-344e-4e3e-886d-979c9ac01698',
        PROPERTY_2: '491b6e2d-e87b-4feb-8f3b-7af4710fc7c3',
      },
      privateAttributes: {},
      storeIds: ['040b41cb-cf0e-4f24-9f85-60527cd5122b'],
      storeInfos: [
        {
          smallImage: null,
          storeId: '040b41cb-cf0e-4f24-9f85-60527cd5122b',
          title: '(Only to test TOAST -Apple-Pay) AET Rush Store QE',
        },
        {
          storeId: '30951341-6bdc-44e2-bf7d-2a4db709e4a8',
          title: '171 Latte macchiato Test',
          address: {
            city: 'boston',
            country: 'United States',
            postalCode: '00500',
            region: 'Massachusetts',
            streetAddress1: 'G4, Royal Arcade Food Court',
            streetAddress2: 'Kirimandala st',
          },
          displayInfo: [
            {
              languageCode: 'EN',
              title: '171 latte macchiato',
              shortDescription: '171 latte macchiato 171 latte macchiato',
              longDescription:
                '171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato',
              smallImage:
                'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/333_157e0383f57a4ce18ef08d10c1428bb6.jpg',
              mediumImage:
                'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/55555_81c8c8a46e924d4fa81d3208a53405d7.jpg',
            },
            {
              languageCode: 'FR',
              title: '171 Casual Dining & Deliveries',
              shortDescription: '171و Casual Dining & Deliveries',
              longDescription:
                '171و Casual Dining & Deliveries \nInspired by great fresh ingredients, our bakeries were transformed to a multi cuisine restaurant in 2014. We continue to fulfill the needs and desires of our guests with a menu of ingredient-inspired food. When you visit our restaurant, you’ll see real kitchens in place of assembly lines. You’ll hear the chopping of over 40 types of fresh herbs, fruits and vegetables, and the sizzle of our real panini grill. You’ll see the stove’s open flame and feel the warmth from our ovens working all day long. They’re the traditions we established years ago that we still passionately follow today.',
              smallImage:
                'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/333_157e0383f57a4ce18ef08d10c1428bb6.jpg',
              mediumImage:
                'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/55555_81c8c8a46e924d4fa81d3208a53405d7.jpg',
            },
          ],
          isCatering: false,
          isMenuBrowsing: false,
          isTest: false,
        },
      ],
      catalogId: '6611784949f61204ffc49480',
      groups: [
        {
          clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
          merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
          externalId: '46084ae7-284d-47c8-8420-452d1d17f289',
          extTargetingId: '46084ae7-284d-47c8-8420-452d1d17f289-extTargetingId',
          title: '(Only to test TOAST -Apple-Pay) AET Rush Store QA - PANINI',
          createdDate: '2024-04-06T16:28:57',
          updatedDate: '2024-04-06T16:28:57',
          startDate: '2024-04-05T16:28:57',
          endDate: '2224-04-06T16:28:57',
          displayRank: 3,
          displayInfo: [
            {
              langCode: 'EN',
              title: 'PANINI',
              shortDescription: '',
              longDescription: '',
              smallImage: [
                'https://incentdev.s3.amazonaws.com/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/g/20240212160405732/sm/PANINI.jpg',
              ],
              mediumImage: [
                'https://incentdev.s3.amazonaws.com/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/g/20240212160405732/md/PANINI.jpg',
              ],
            },
          ],
          status: 'ACTIVE',
          applicableOrderTypes: ['DELIVERY', 'PICKUP'],
          extendedAttributes: {},
          privateAttributes: {},
          storeIds: ['040b41cb-cf0e-4f24-9f85-60527cd5122b'],
          groupId: '6611784949f61204ffc4946d',
          groupType: 'CATALOG_GROUP',
          itemIds: [
            '6611784949f61204ffc4945a',
            '6611784949f61204ffc4946b',
            '6611784949f61204ffc4946c',
            '6611784949f61204ffc4945f',
            '6611784949f61204ffc49469',
            '6611784949f61204ffc49460',
            '6611784949f61204ffc49461',
            '6611784949f61204ffc4946a',
          ],
          defaultSelectedItems: [],
          mandatoryItems: [],
          optionGroupIds: [
            '6611784949f61204ffc4944a',
            '6611784949f61204ffc49414',
          ],
          subGroupIds: ['6611784949f61204ffc49442'],
          selectionMandatory: false,
          inheritParentOptions: false,
          maxItemSelections: 0,
          minItemSelections: 0,
          groupItemSettings: [
            {
              itemId: '6611784949f61204ffc49469',
              itemGuid: 'f374352e-0259-4136-a700-27036575fa58',
              maxItemSelections: 0,
              price: 11000,
              isDefault: null,
              displayRank: 5,
            },
            {
              itemId: '6611784949f61204ffc4945f',
              itemGuid: '0922f685-48c0-4988-8fb1-2661377a0619',
              maxItemSelections: 0,
              price: 0,
              isDefault: null,
              displayRank: 2,
            },
            {
              itemId: '6611784949f61204ffc4945a',
              itemGuid: 'aa7bbcf2-256e-4581-946a-4d2bcdf3acc7',
              maxItemSelections: 0,
              price: 0,
              isDefault: null,
              displayRank: 1,
            },
            {
              itemId: '6611784949f61204ffc4946b',
              itemGuid: '46e8c124-a1be-433a-8d2a-7f51e3208949',
              maxItemSelections: 0,
              price: 12370,
              isDefault: null,
              displayRank: 7,
            },
            {
              itemId: '6611784949f61204ffc49461',
              itemGuid: '05aa1c91-5ac7-41a1-9a96-c8a3370eff22',
              maxItemSelections: 0,
              price: 0,
              isDefault: null,
              displayRank: 4,
            },
            {
              itemId: '6611784949f61204ffc4946a',
              itemGuid: 'cc0c6867-43c6-434b-a11a-94198dcc2dbe',
              maxItemSelections: 0,
              price: 0,
              isDefault: null,
              displayRank: 6,
            },
            {
              itemId: '6611784949f61204ffc49460',
              itemGuid: 'b7815fea-ef64-453b-a98e-4bbee2c6b292',
              maxItemSelections: 0,
              price: 0,
              isDefault: null,
              displayRank: 3,
            },
            {
              itemId: '6611784949f61204ffc4946c',
              itemGuid: '9f3e247f-4643-4614-a6c1-5abc6631eaee',
              maxItemSelections: 0,
              price: 15980,
              isDefault: null,
              displayRank: 8,
            },
          ],
        },
        {
          clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
          merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
          externalId: 'b576205e-fc95-48ff-9c07-64b625d657ad',
          extTargetingId: 'b576205e-fc95-48ff-9c07-64b625d657ad-extTargetingId',
          title:
            '(Only to test TOAST -Apple-Pay) AET Rush Store QA - VisibilityTest',
          createdDate: '2024-04-06T16:28:57',
          updatedDate: '2024-04-06T16:28:57',
          startDate: '2024-04-05T16:28:57',
          endDate: '2224-04-06T16:28:57',
          displayRank: 5,
          displayInfo: [
            {
              langCode: 'EN',
              title: 'VisibilityTest',
              shortDescription: '',
              longDescription: '',
              smallImage: [],
              mediumImage: [],
            },
          ],
          status: 'INACTIVE',
          applicableOrderTypes: ['DELIVERY', 'PICKUP'],
          extendedAttributes: {},
          privateAttributes: {},
          storeIds: ['040b41cb-cf0e-4f24-9f85-60527cd5122b'],
          groupId: '6611784949f61204ffc4947e',
          groupType: 'CATALOG_GROUP',
          itemIds: ['6611784949f61204ffc4947d'],
          defaultSelectedItems: [],
          mandatoryItems: [],
          optionGroupIds: ['6611784949f61204ffc4947c'],
          subGroupIds: [],
          selectionMandatory: false,
          inheritParentOptions: false,
          maxItemSelections: 0,
          minItemSelections: 0,
          groupItemSettings: [
            {
              itemId: '6611784949f61204ffc4947d',
              itemGuid: '34e58ea1-9761-464b-8443-6f3313af790e',
              maxItemSelections: 0,
              price: 9000,
              isDefault: null,
              displayRank: 1,
            },
          ],
        },
        {
          clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
          merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
          externalId: '9fd84215-7c08-46a0-a20c-229a630ec078',
          extTargetingId: '9fd84215-7c08-46a0-a20c-229a630ec078-extTargetingId',
          title: '(Only to test TOAST -Apple-Pay) AET Rush Store QA - Soups',
          createdDate: '2024-04-06T16:28:57',
          updatedDate: '2024-04-06T16:28:57',
          startDate: '2024-04-05T16:28:57',
          endDate: '2224-04-06T16:28:57',
          displayRank: 1,
          displayInfo: [
            {
              langCode: 'EN',
              title: 'Soups',
              shortDescription: '',
              longDescription: '',
              smallImage: [
                'https://incentdev.s3.amazonaws.com/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/g/20231206142314629/sm/Soups.jpg',
              ],
              mediumImage: [
                'https://incentdev.s3.amazonaws.com/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/g/20231206142314629/md/Soups.jpg',
              ],
            },
          ],
          status: 'ACTIVE',
          applicableOrderTypes: ['DELIVERY', 'PICKUP'],
          extendedAttributes: {},
          privateAttributes: {},
          storeIds: ['040b41cb-cf0e-4f24-9f85-60527cd5122b'],
          groupId: '6611784949f61204ffc49421',
          groupType: 'CATALOG_GROUP',
          itemIds: [
            '6611784949f61204ffc493e5',
            '6611784949f61204ffc4941a',
            '6611784949f61204ffc4941b',
            '6611784949f61204ffc4941c',
            '6611784949f61204ffc4941d',
            '6611784949f61204ffc49415',
            '6611784949f61204ffc49417',
            '6611784949f61204ffc49418',
            '6611784949f61204ffc49419',
            '6611784949f61204ffc493db',
            '6611784949f61204ffc49420',
            '6611784949f61204ffc4941e',
            '6611784949f61204ffc4941f',
          ],
          defaultSelectedItems: [],
          mandatoryItems: [],
          optionGroupIds: [],
          subGroupIds: [],
          selectionMandatory: false,
          inheritParentOptions: false,
          maxItemSelections: 0,
          minItemSelections: 0,
          groupItemSettings: [
            {
              itemId: '6611784949f61204ffc4941e',
              itemGuid: 'cb1c9eb2-7bad-4d36-8ed8-112605a4f9ce',
              maxItemSelections: 0,
              price: 8970,
              isDefault: null,
              displayRank: 11,
            },
            {
              itemId: '6611784949f61204ffc4941c',
              itemGuid: 'c5a453fb-cf08-4403-8c59-c1fd414fdaa7',
              maxItemSelections: 0,
              price: 15330,
              isDefault: null,
              displayRank: 9,
            },
            {
              itemId: '6611784949f61204ffc49415',
              itemGuid: '821a86f8-9e9d-41fb-a82d-6cefd60ef826',
              maxItemSelections: 0,
              price: 9430,
              isDefault: null,
              displayRank: 2,
            },
            {
              itemId: '6611784949f61204ffc4941b',
              itemGuid: '672194dc-87e7-4ef2-bfa6-cedd44280df9',
              maxItemSelections: 0,
              price: 5440,
              isDefault: null,
              displayRank: 8,
            },
            {
              itemId: '6611784949f61204ffc4941d',
              itemGuid: 'fd0c5ca9-ebf6-472f-9746-ec5a88e5d1a4',
              maxItemSelections: 0,
              price: 10990,
              isDefault: null,
              displayRank: 10,
            },
            {
              itemId: '6611784949f61204ffc4941f',
              itemGuid: '21dc9bfe-963b-4a7c-85e3-8e61241ef517',
              maxItemSelections: 0,
              price: 11700,
              isDefault: null,
              displayRank: 12,
            },
            {
              itemId: '6611784949f61204ffc49420',
              itemGuid: '324959ce-298e-430c-b37b-5057141a7502',
              maxItemSelections: 0,
              price: 12090,
              isDefault: null,
              displayRank: 13,
            },
            {
              itemId: '6611784949f61204ffc49419',
              itemGuid: 'f9185296-b87e-453a-b066-a24291d8144c',
              maxItemSelections: 0,
              price: 7500,
              isDefault: null,
              displayRank: 6,
            },
            {
              itemId: '6611784949f61204ffc49417',
              itemGuid: '9e1eaeed-8818-4d80-b92f-68c99a0d17e5',
              maxItemSelections: 0,
              price: 5880,
              isDefault: null,
              displayRank: 3,
            },
            {
              itemId: '6611784949f61204ffc49418',
              itemGuid: '80a249f0-2e1a-4506-97f1-56f2cb8fe982',
              maxItemSelections: 0,
              price: 15770,
              isDefault: null,
              displayRank: 5,
            },
            {
              itemId: '6611784949f61204ffc493db',
              itemGuid: 'ab678076-c983-48f3-a795-dce921d477d7',
              maxItemSelections: 0,
              price: 10000,
              isDefault: null,
              displayRank: 4,
            },
            {
              itemId: '6611784949f61204ffc493e5',
              itemGuid: 'a4e4bb61-badb-4bd0-b528-f376facf526e',
              maxItemSelections: 0,
              price: 10750,
              isDefault: null,
              displayRank: 1,
            },
            {
              itemId: '6611784949f61204ffc4941a',
              itemGuid: 'e7266f33-b886-4da6-aca5-352c6ec21ce2',
              maxItemSelections: 0,
              price: 10340,
              isDefault: null,
              displayRank: 7,
            },
          ],
        },
        {
          clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
          merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
          externalId: 'b199ac8c-fdeb-4d18-bd17-6411e262ea64',
          extTargetingId: 'b199ac8c-fdeb-4d18-bd17-6411e262ea64-extTargetingId',
          title:
            '(Only to test TOAST -Apple-Pay) AET Rush Store QA - 3RD PARTY DELIVERY',
          createdDate: '2024-04-06T16:28:57',
          updatedDate: '2024-04-06T16:28:57',
          startDate: '2024-04-05T16:28:57',
          endDate: '2224-04-06T16:28:57',
          displayRank: 6,
          displayInfo: [
            {
              langCode: 'EN',
              title: '3RD PARTY DELIVERY',
              shortDescription: '',
              longDescription: '',
              smallImage: [],
              mediumImage: [],
            },
          ],
          status: 'ACTIVE',
          applicableOrderTypes: ['DELIVERY', 'PICKUP'],
          extendedAttributes: {},
          privateAttributes: {},
          storeIds: ['040b41cb-cf0e-4f24-9f85-60527cd5122b'],
          groupId: '6611784949f61204ffc4947f',
          groupType: 'CATALOG_GROUP',
          itemIds: [],
          defaultSelectedItems: [],
          mandatoryItems: [],
          optionGroupIds: [],
          subGroupIds: [],
          selectionMandatory: false,
          inheritParentOptions: false,
          maxItemSelections: 0,
          minItemSelections: 0,
          groupItemSettings: [],
        },
        {
          clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
          merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
          externalId: '31e2bc8b-53c0-4144-b05f-cbc13e0fafa4',
          extTargetingId: '31e2bc8b-53c0-4144-b05f-cbc13e0fafa4-extTargetingId',
          title:
            '(Only to test TOAST -Apple-Pay) AET Rush Store QA - Appetizers (Copy)',
          createdDate: '2024-04-06T16:28:57',
          updatedDate: '2024-04-06T16:28:57',
          startDate: '2024-04-05T16:28:57',
          endDate: '2224-04-06T16:28:57',
          displayRank: 2,
          displayInfo: [
            {
              langCode: 'EN',
              title: 'Appetizers (Copy)',
              shortDescription: 'Appetizers from Toast',
              longDescription: '',
              smallImage: [
                'https://incentdev.s3.amazonaws.com/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/g/IAC%20-%20TOAST%20-%20Appetizers%20%28Copy%29_1.jpg',
              ],
              mediumImage: [
                'https://incentdev.s3.amazonaws.com/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/g/IAC%20-%20TOAST%20-%20Appetizers%20%28Copy%29_1-md.jpg',
              ],
            },
          ],
          status: 'ACTIVE',
          applicableOrderTypes: ['DELIVERY', 'PICKUP'],
          extendedAttributes: {},
          privateAttributes: {},
          storeIds: ['040b41cb-cf0e-4f24-9f85-60527cd5122b'],
          groupId: '6611784949f61204ffc4942c',
          groupType: 'CATALOG_GROUP',
          itemIds: [
            '6611784949f61204ffc4942b',
            '6611784949f61204ffc49429',
            '6611784949f61204ffc49418',
          ],
          defaultSelectedItems: [],
          mandatoryItems: [],
          optionGroupIds: [
            '6611784949f61204ffc4942a',
            '6611784949f61204ffc49423',
          ],
          subGroupIds: [],
          selectionMandatory: false,
          inheritParentOptions: false,
          maxItemSelections: 0,
          minItemSelections: 0,
          groupItemSettings: [
            {
              itemId: '6611784949f61204ffc4942b',
              itemGuid: 'bd982387-70a3-461b-9526-d4011046f80f',
              maxItemSelections: 0,
              price: 8550,
              isDefault: null,
              displayRank: 3,
            },
            {
              itemId: '6611784949f61204ffc49418',
              itemGuid: '80a249f0-2e1a-4506-97f1-56f2cb8fe982',
              maxItemSelections: 0,
              price: 15770,
              isDefault: null,
              displayRank: 2,
            },
            {
              itemId: '6611784949f61204ffc49429',
              itemGuid: '9848c795-1920-4482-9000-7973df790bcb',
              maxItemSelections: 0,
              price: 12000,
              isDefault: null,
              displayRank: 1,
            },
          ],
        },
        {
          clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
          merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
          externalId: '696db88e-d4dc-40ae-8640-dfa605ed899f',
          extTargetingId: '696db88e-d4dc-40ae-8640-dfa605ed899f-extTargetingId',
          title: '(Only to test TOAST -Apple-Pay) AET Rush Store QA - PANINI 2',
          createdDate: '2024-04-06T16:28:57',
          updatedDate: '2024-04-06T16:28:57',
          startDate: '2024-04-05T16:28:57',
          endDate: '2224-04-06T16:28:57',
          displayRank: 4,
          displayInfo: [
            {
              langCode: 'EN',
              title: 'PANINI 2',
              shortDescription: '',
              longDescription: '',
              smallImage: [
                'https://incentdev.s3.amazonaws.com/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/g/20231121060609698/sm/PANINI%202.jpg',
              ],
              mediumImage: [
                'https://incentdev.s3.amazonaws.com/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/g/20231121060609698/md/PANINI%202.jpg',
              ],
            },
          ],
          status: 'ACTIVE',
          applicableOrderTypes: ['DELIVERY', 'PICKUP'],
          extendedAttributes: {},
          privateAttributes: {},
          storeIds: ['040b41cb-cf0e-4f24-9f85-60527cd5122b'],
          groupId: '6611784949f61204ffc49478',
          groupType: 'CATALOG_GROUP',
          itemIds: [
            '6611784949f61204ffc49473',
            '6611784949f61204ffc49474',
            '6611784949f61204ffc49475',
            '6611784949f61204ffc49476',
            '6611784949f61204ffc49477',
            '6611784949f61204ffc49472',
          ],
          defaultSelectedItems: [],
          mandatoryItems: [],
          optionGroupIds: [
            '6611784949f61204ffc4942a',
            '6611784949f61204ffc49471',
            '6611784949f61204ffc493e1',
          ],
          subGroupIds: ['6611784949f61204ffc4946e'],
          selectionMandatory: false,
          inheritParentOptions: false,
          maxItemSelections: 0,
          minItemSelections: 0,
          groupItemSettings: [
            {
              itemId: '6611784949f61204ffc49473',
              itemGuid: 'ed0a8046-ba44-4eb3-a619-1d1d8c7a1830',
              maxItemSelections: 0,
              price: 0,
              isDefault: null,
              displayRank: 2,
            },
            {
              itemId: '6611784949f61204ffc49475',
              itemGuid: '4065d1df-3d83-4c5f-855f-f1ddef81aaa2',
              maxItemSelections: 0,
              price: 0,
              isDefault: null,
              displayRank: 4,
            },
            {
              itemId: '6611784949f61204ffc49474',
              itemGuid: '5b579dbe-1000-4598-bb44-5578457979d9',
              maxItemSelections: 0,
              price: 6200,
              isDefault: null,
              displayRank: 3,
            },
            {
              itemId: '6611784949f61204ffc49476',
              itemGuid: '08a26916-bf16-4eb4-adee-ea00b31e3597',
              maxItemSelections: 0,
              price: 15700,
              isDefault: null,
              displayRank: 5,
            },
            {
              itemId: '6611784949f61204ffc49477',
              itemGuid: '46b86856-10cc-4fa4-bd84-3dc50a30c757',
              maxItemSelections: 0,
              price: 13350,
              isDefault: null,
              displayRank: 6,
            },
            {
              itemId: '6611784949f61204ffc49472',
              itemGuid: 'b7440633-e99c-4662-9c9b-7109d2a2332e',
              maxItemSelections: 0,
              price: 0,
              isDefault: null,
              displayRank: 1,
            },
          ],
        },
      ],
      groupIds: [
        '6611784949f61204ffc4946d',
        '6611784949f61204ffc4947e',
        '6611784949f61204ffc49421',
        '6611784949f61204ffc4947f',
        '6611784949f61204ffc4942c',
        '6611784949f61204ffc49478',
      ],
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: 'deba7034-4e11-4645-b4a8-47c41d0c5fb0',
      extTargetingId: 'deba7034-4e11-4645-b4a8-47c41d0c5fb0-extTargetingId',
      title:
        "(Only to test TOAST -Apple-Pay) AET Rush Store QA - QA Test Menu (Don't Edit)",
      createdDate: '2024-04-06T16:28:57',
      updatedDate: '2024-04-06T16:28:57',
      startDate: '2024-04-05T16:28:57',
      endDate: '2224-04-06T16:28:57',
      displayRank: 1,
      displayInfo: [
        {
          langCode: 'EN',
          title: "QA Test Menu (Don't Edit)",
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'ACTIVE',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['040b41cb-cf0e-4f24-9f85-60527cd5122b'],
      catalogId: '6611784949f61204ffc494ba',
      groups: [
        {
          clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
          merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
          externalId: '20aa79d4-f8a2-445d-80fd-e00802c39f54',
          extTargetingId: '20aa79d4-f8a2-445d-80fd-e00802c39f54-extTargetingId',
          title: '(Only to test TOAST -Apple-Pay) AET Rush Store QA - Soups',
          createdDate: '2024-04-06T16:28:57',
          updatedDate: '2024-04-06T16:28:57',
          startDate: '2024-04-05T16:28:57',
          endDate: '2224-04-06T16:28:57',
          displayRank: 1,
          displayInfo: [
            {
              langCode: 'EN',
              title: 'Soups',
              shortDescription: '',
              longDescription: '',
              smallImage: [
                'https://incentdev.s3.amazonaws.com/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/g/20231206142314629/sm/Soups.jpg',
              ],
              mediumImage: [
                'https://incentdev.s3.amazonaws.com/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/g/20231206142314629/md/Soups.jpg',
              ],
            },
          ],
          status: 'ACTIVE',
          applicableOrderTypes: ['DELIVERY', 'PICKUP'],
          extendedAttributes: {},
          privateAttributes: {},
          storeIds: ['040b41cb-cf0e-4f24-9f85-60527cd5122b'],
          groupId: '6611784949f61204ffc494b4',
          groupType: 'CATALOG_GROUP',
          itemIds: [
            '6611784949f61204ffc493db',
            '6611784949f61204ffc493e5',
            '6611784949f61204ffc494b1',
            '6611784949f61204ffc494b2',
            '6611784949f61204ffc494b3',
            '6611784949f61204ffc49415',
            '6611784949f61204ffc494a7',
            '6611784949f61204ffc494a8',
            '6611784949f61204ffc4949c',
            '6611784949f61204ffc4949d',
          ],
          defaultSelectedItems: [],
          mandatoryItems: [],
          optionGroupIds: [],
          subGroupIds: [],
          selectionMandatory: false,
          inheritParentOptions: false,
          maxItemSelections: 0,
          minItemSelections: 0,
          groupItemSettings: [
            {
              itemId: '6611784949f61204ffc494b3',
              itemGuid: 'a2a8d9f5-d6af-439f-9dd6-ff2d9e3eadba',
              maxItemSelections: 0,
              price: 0,
              isDefault: null,
              displayRank: 10,
            },
            {
              itemId: '6611784949f61204ffc4949c',
              itemGuid: 'd8d4806f-578a-4556-90c2-814d87d42c63',
              maxItemSelections: 0,
              price: 0,
              isDefault: null,
              displayRank: 4,
            },
            {
              itemId: '6611784949f61204ffc494b1',
              itemGuid: '55778d0a-7fb1-4396-989a-11468d6929eb',
              maxItemSelections: 0,
              price: 9990,
              isDefault: null,
              displayRank: 8,
            },
            {
              itemId: '6611784949f61204ffc494a8',
              itemGuid: '6531b82c-e19e-477e-be54-513456aad714',
              maxItemSelections: 0,
              price: 3000,
              isDefault: null,
              displayRank: 7,
            },
            {
              itemId: '6611784949f61204ffc494b2',
              itemGuid: 'a8ef61ee-1de8-443c-8250-a6241515029a',
              maxItemSelections: 0,
              price: 12340,
              isDefault: null,
              displayRank: 9,
            },
            {
              itemId: '6611784949f61204ffc494a7',
              itemGuid: 'b9eceffe-7214-47a2-bb2c-31a5ac43b793',
              maxItemSelections: 0,
              price: 1000,
              isDefault: null,
              displayRank: 6,
            },
            {
              itemId: '6611784949f61204ffc49415',
              itemGuid: '821a86f8-9e9d-41fb-a82d-6cefd60ef826',
              maxItemSelections: 0,
              price: 9430,
              isDefault: null,
              displayRank: 2,
            },
            {
              itemId: '6611784949f61204ffc493db',
              itemGuid: 'ab678076-c983-48f3-a795-dce921d477d7',
              maxItemSelections: 0,
              price: 10000,
              isDefault: null,
              displayRank: 3,
            },
            {
              itemId: '6611784949f61204ffc4949d',
              itemGuid: '8b188089-51ee-4f34-a583-5ff0196dfe18',
              maxItemSelections: 0,
              price: 7000,
              isDefault: null,
              displayRank: 5,
            },
            {
              itemId: '6611784949f61204ffc493e5',
              itemGuid: 'a4e4bb61-badb-4bd0-b528-f376facf526e',
              maxItemSelections: 0,
              price: 10750,
              isDefault: null,
              displayRank: 1,
            },
          ],
        },
        {
          clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
          merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
          externalId: '7321c1b0-0104-4c8e-9f9d-d11909be294b',
          extTargetingId: '7321c1b0-0104-4c8e-9f9d-d11909be294b-extTargetingId',
          title:
            '(Only to test TOAST -Apple-Pay) AET Rush Store QA - Beer (Copy)',
          createdDate: '2024-04-06T16:28:57',
          updatedDate: '2024-04-06T16:28:57',
          startDate: '2024-04-05T16:28:57',
          endDate: '2224-04-06T16:28:57',
          displayRank: 2,
          displayInfo: [
            {
              langCode: 'EN',
              title: 'Beer (Copy)',
              shortDescription: '',
              longDescription: '',
              smallImage: [
                'https://incentdev.s3.amazonaws.com/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/g/Boston%20QA%20-%20Beer%20%28Copy%29SM-61efd553_1.gif',
              ],
              mediumImage: [
                'https://incentdev.s3.amazonaws.com/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/g/Boston%20QA%20-%20Beer%20%28Copy%29MD-61efd628_1-md.gif',
              ],
            },
          ],
          status: 'ACTIVE',
          applicableOrderTypes: ['DELIVERY', 'PICKUP'],
          extendedAttributes: {},
          privateAttributes: {},
          storeIds: ['040b41cb-cf0e-4f24-9f85-60527cd5122b'],
          groupId: '6611784949f61204ffc494b9',
          groupType: 'CATALOG_GROUP',
          itemIds: [
            '6611784949f61204ffc494b5',
            '6611784949f61204ffc494b6',
            '6611784949f61204ffc494b7',
            '6611784949f61204ffc494b8',
          ],
          defaultSelectedItems: [],
          mandatoryItems: [],
          optionGroupIds: [],
          subGroupIds: [],
          selectionMandatory: false,
          inheritParentOptions: false,
          maxItemSelections: 0,
          minItemSelections: 0,
          groupItemSettings: [
            {
              itemId: '6611784949f61204ffc494b7',
              itemGuid: '7cc7c933-f01d-4631-ad51-07ead5d0c2f5',
              maxItemSelections: 0,
              price: 6500,
              isDefault: null,
              displayRank: 3,
            },
            {
              itemId: '6611784949f61204ffc494b8',
              itemGuid: 'df3c2b5b-894b-4c9e-8e17-6f14ffbe9631',
              maxItemSelections: 0,
              price: 5000,
              isDefault: null,
              displayRank: 4,
            },
            {
              itemId: '6611784949f61204ffc494b6',
              itemGuid: '166f71ad-cd6e-4a35-b1a2-8ef0377050db',
              maxItemSelections: 0,
              price: 8500,
              isDefault: null,
              displayRank: 2,
            },
            {
              itemId: '6611784949f61204ffc494b5',
              itemGuid: '1fc4b1dd-05be-4b73-92ad-2dbe5aaeb9aa',
              maxItemSelections: 0,
              price: 0,
              isDefault: null,
              displayRank: 1,
            },
          ],
        },
      ],
      groupIds: ['6611784949f61204ffc494b4', '6611784949f61204ffc494b9'],
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: '81295109-e321-4001-94e4-2aa98eae77ce',
      extTargetingId: '81295109-e321-4001-94e4-2aa98eae77ce-extTargetingId',
      title:
        '(Only to test TOAST -Apple-Pay) AET Rush Store QA - QA Test Toast Menu- qty Modifier',
      createdDate: '2024-04-06T16:28:57',
      updatedDate: '2024-04-06T16:28:57',
      startDate: '2024-04-05T16:28:57',
      endDate: '2224-04-06T16:28:57',
      displayRank: 3,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'QA Test Toast Menu- qty Modifier',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'INACTIVE',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['040b41cb-cf0e-4f24-9f85-60527cd5122b'],
      storeInfos: [
        {
          smallImage: null,
          storeId: '040b41cb-cf0e-4f24-9f85-60527cd5122b',
          title: '(Only to test TOAST -Apple-Pay) AET Rush Store QE',
        },
      ],
      catalogId: '6611784949f61204ffc494da',
      groups: [
        {
          clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
          merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
          externalId: 'ebb78dc8-e0da-46c5-bdf8-b2ed3d3de00c',
          extTargetingId: 'ebb78dc8-e0da-46c5-bdf8-b2ed3d3de00c-extTargetingId',
          title:
            '(Only to test TOAST -Apple-Pay) AET Rush Store QA - QA Test Group Qty A',
          createdDate: '2024-04-06T16:28:57',
          updatedDate: '2024-04-06T16:28:57',
          startDate: '2024-04-05T16:28:57',
          endDate: '2224-04-06T16:28:57',
          displayRank: 1,
          displayInfo: [
            {
              langCode: 'EN',
              title: 'QA Test Group Qty A',
              shortDescription: '',
              longDescription: '',
              smallImage: [],
              mediumImage: [],
            },
          ],
          status: 'ACTIVE',
          applicableOrderTypes: ['DELIVERY', 'PICKUP'],
          extendedAttributes: {},
          privateAttributes: {},
          storeIds: ['040b41cb-cf0e-4f24-9f85-60527cd5122b'],
          groupId: '6611784949f61204ffc494d9',
          groupType: 'CATALOG_GROUP',
          itemIds: [
            '6611784949f61204ffc494c0',
            '6611784949f61204ffc4944b',
            '6611784949f61204ffc494c1',
            '6611784949f61204ffc494d8',
          ],
          defaultSelectedItems: [],
          mandatoryItems: [],
          optionGroupIds: ['6611784949f61204ffc4940e'],
          subGroupIds: ['6611784949f61204ffc494bc'],
          selectionMandatory: false,
          inheritParentOptions: false,
          maxItemSelections: 0,
          minItemSelections: 0,
          groupItemSettings: [
            {
              itemId: '6611784949f61204ffc4944b',
              itemGuid: 'eda5bb24-b525-458b-8b73-c0cf3382f93c',
              maxItemSelections: 0,
              price: 6250,
              isDefault: null,
              displayRank: 1,
            },
            {
              itemId: '6611784949f61204ffc494d8',
              itemGuid: '6a40931e-b432-468c-bf9f-161ebbabe671',
              maxItemSelections: 0,
              price: 11950,
              isDefault: null,
              displayRank: 4,
            },
            {
              itemId: '6611784949f61204ffc494c0',
              itemGuid: '167fa491-b158-4e72-aa33-7c27643ece7b',
              maxItemSelections: 0,
              price: 5000,
              isDefault: null,
              displayRank: 2,
            },
            {
              itemId: '6611784949f61204ffc494c1',
              itemGuid: '2e6b909c-2183-4613-b368-b6802c15853f',
              maxItemSelections: 0,
              price: 3000,
              isDefault: null,
              displayRank: 3,
            },
          ],
        },
      ],
      groupIds: ['6611784949f61204ffc494d9'],
    },
  ],
  paging: {
    total: 3,
    count: 300,
    totalPages: 1,
    currentPage: 0,
  },
};

export const emptyCatalogs = {
  catalogs: [],
  paging: { total: 184, count: 1000, totalPages: 1, currentPage: 0 },
};

export const allCatalogs = {
  externalLocationId: '8e8c7ec2-6c41-4520-8898-83c705d6e1cd',
  catalogs: [
    {
      catalogId: '1dc02b89-c9a1-46db-a4ff-76e55b64349d',
      title: 'Sample Menu',
    },
    {
      catalogId: '2b21a954-d999-4d12-a7a6-e8b35f492eff',
      title: 'T STARR Test Toast Menu',
    },
    {
      catalogId: '2dd4279a-da21-4cd1-8f27-12f5cbf6d4f5',
      title: 'duplicate Menu',
    },
    {
      catalogId: '3c1ab7fc-3e23-4666-9234-b9b22d991047',
      title: 'Large Menu',
    },
    {
      catalogId: '3e89f168-f0d4-40f7-9a27-24b761032b01',
      title: 'Test Menu may 19',
    },
    {
      catalogId: '4453d2f5-1324-4250-981e-da8bad93dcea',
      title: 'Menu with noItems_noGroups',
    },
    {
      catalogId: '469e7e47-ac03-4ba7-9462-06e2f86aafb3',
      title: "Toast Test Regression Menu -  (Don't Edit)",
    },
    {
      catalogId: '4cda013d-3262-4d68-ba90-9b02a800ff6e',
      title: 'DisplayRankMenu',
    },
    {
      catalogId: '534588dc-c470-4731-b37e-0289a42b2313',
      title: 'Brand New Menu',
    },
    {
      catalogId: '5859db73-2640-45cd-9716-fbe97b3a9e38',
      title: 'Test Menu B',
    },
    {
      catalogId: '6ca2d4d0-7f48-407c-8989-09f2379f96b3',
      title: 'Dynamic Pricing Test Menu QA',
    },
    {
      catalogId: '6efddf58-9ac1-44dd-9d4a-955780d36e52',
      title: 'Multiple Groups with subgroups',
    },
    {
      catalogId: '81295109-e321-4001-94e4-2aa98eae77ce',
      title: 'QA Test Toast Menu- qty Modifier',
    },
    {
      catalogId: '816eefce-6038-41bd-a0a2-06ff3dcc41ea',
      title: 'KT Test Menu',
    },
    {
      catalogId: '82c6480c-8fbc-40d6-9379-ec5551093f12',
      title: 'Single Menu',
    },
    {
      catalogId: '86e6cd64-a1f1-41c1-bf99-b7be79aebee6',
      title: 'Automation Menu 2',
    },
    {
      catalogId: '8913219f-0b86-41be-be35-2079ebbd995c',
      title: 'Third Party Delivery Tip Mapping',
    },
    {
      catalogId: '9207ae08-a5bf-4706-a3a8-8cc99b8ce26f',
      title: "Automation Toast Menu (Don't Edit)",
    },
    {
      catalogId: 'ace2c90c-9962-4364-aef4-481c7ddf3f00',
      title: "Test Scenarios Menu (Don't Edit)",
    },
    {
      catalogId: 'b3b2c218-c841-497c-bdd8-0c5133794639',
      title: 'Test Menu ML',
    },
    {
      catalogId: 'b5bcf52d-e95f-43c1-bbfa-18b6507db135',
      title: "Google Ordering Menu - Don't Edit",
    },
    {
      catalogId: 'c6906dd9-badb-459e-93e5-1ce87f42aba8',
      title: 'Bad Ass Coffee (Replica)',
    },
    {
      catalogId: 'c7aff5ef-2080-4368-b983-05f4a6b7d6d1',
      title: 'New Toast Import menu',
    },
    {
      catalogId: 'c8ef8091-ee2a-401e-bfb6-e893f504a5bb',
      title: 'Pre selected Menu',
    },
    {
      catalogId: 'cd76056d-1aad-4669-8c6e-dd0811bb8d2d',
      title: 'Single Menu Single group with sub groups',
    },
    {
      catalogId: 'd75972f2-656c-4d0e-b2aa-fd45958ade5e',
      title: 'Fenway',
    },
    {
      catalogId: 'd7e72694-71ca-4a51-84a3-b3f7d21ecce9',
      title: 'Urban Bricks',
    },
    {
      catalogId: 'd91fbe7f-de52-41b3-aeea-7f9bbf6e4d3c',
      title: 'Basic Menu',
    },
    {
      catalogId: 'deba7034-4e11-4645-b4a8-47c41d0c5fb0',
      title: "QA Test Menu (Don't Edit)",
    },
    {
      catalogId: 'f00240e6-9093-43c5-b942-5b474b5afcff',
      title: 'Pizza Menu',
    },
    {
      catalogId: 'f2f7d615-6f66-4063-81fd-2e2543afe842',
      title: 'Build Your Own',
    },
    {
      catalogId: 'f83ff24d-d8b6-4a3f-9b1c-d237f43c0723',
      title: 'Test Menu A',
    },
  ],
  paging: {
    total: 32,
    count: 300,
    totalPages: 1,
    currentPage: 0,
  },
  message: null,
};
